export const ANALYTICS_EVENT_REQUEST = "ANALYTICS_EVENT_REQUEST";
export const ANALYTICS_EVENT_SUCCESS = "ANALYTICS_EVENT_SUCCESS";
export const ANALYTICS_EVENT_FAILED = "ANALYTICS_EVENT_FAILED";

export const requestAnalyticsEventAction = (payload,successcallback=()=>{},failcallback=()=>{}) => {	
	payload.timestamp = Date.now();
	payload.userAgent = navigator.userAgent; 
	return { type: ANALYTICS_EVENT_REQUEST, payload,successcallback,failcallback };
}; 